import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function ConfirmDialog({openAddress, setOpenAddress, handleSaveAddress, item, message}) {
    return (
        <>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenAddress(false)} open={openAddress}>
                <DialogTitle id='dialog-title'>
                    Save the address for future purchases ?
                </DialogTitle>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenAddress(false)}
                        variant="contained"
                        >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleSaveAddress()}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}